module.exports = __webpack_public_path__ + "static/media/Upload-Highlighted.6c9eabf6.svg";